// extracted by mini-css-extract-plugin
export default {"form":"CreateDevice_form__nU7VL"};